module.exports = __webpack_public_path__ + "static/media/04baojieyuan.40c46a72.png";